// extracted by mini-css-extract-plugin
export default {"titleActions":"KJYxHUNcEK6L7H2kRjdc","foodsTable":"OVUT2OpWuFg2v0Nigefs","scrollContainer":"rU4KUVYMFaAIlfx2FGXa","pagination":"EeBL_wigCnAwCD4uA36p"};